import { render, staticRenderFns } from "./TopNavTabs.vue?vue&type=template&id=006b2aca&scoped=true&lang=pug&"
import script from "./TopNavTabs.vue?vue&type=script&lang=js&"
export * from "./TopNavTabs.vue?vue&type=script&lang=js&"
import style0 from "./TopNavTabs.vue?vue&type=style&index=0&id=006b2aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b2aca",
  null
  
)

export default component.exports